// export interface FormatOptions {
// }
export function format(input, replacements) {
    // tslint:disable-next-line: forin
    for (const key in replacements) {
        input = input.replace(new RegExp(`\{${key}\}`, 'g'), replacements[key]);
    }
    return input;
}
